import Image from 'next/future/image';
import { useTranslation } from 'react-i18next';
import React, { Fragment, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import MyHead from '../../components/MyHead';
import Marquee from '@/components/v2/Pages/About/Marquee';
import StaticPagesCards from '@/components/v2/StaticPagesCards';

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  // TODO: @naim ref non mi funziona per tutte e tre le animazioni di parallasse
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['-600px', '600px']
  });
  const yBg = useTransform(scrollYProgress, [0, 1], ['-5%', '5%']);

  return (
    <Fragment>
      <MyHead />

      <div className="section full">
        <div className="section-wrapper">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-8 col-span-12">
              <div className="tracking-uyn uppercase md:text-xl opacity-80 mb-2">
                {t('P_ABOUT.SECTION-1.TOPTITLE')}
              </div>
              <div className="h2">{t('P_ABOUT.SECTION-1.TITLE')}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="section full">
        <div className="section-wrapper">
          <div className="grid gap-8 grid-cols-12">
            <div className="md:col-span-6 col-span-10">
              <Image
                src="/v2/about/about-1.jpg"
                alt=""
                width={0}
                height={0}
                priority
                sizes="100vw"
                className="w-full"
              />

              <Image
                src="/v2/about/about-2.jpg"
                alt=""
                width={0}
                height={0}
                priority
                sizes="100vw"
                className="w-full xl:max-w-[400px] md:max-w-[200px] max-w-[240px] ml-auto md:mr-[-5%] xl:mr-[-25%] mr-[-15%] xl:mt-[-20%] md:mt-[-25%] mt-[-30%]"
              />
            </div>
            <div className="md:col-span-5 col-span-12 md:col-start-8 md:pt-10">
              <div className="h3 max-w-[540px]">
                {t('P_ABOUT.SECTION-2.TITLE')}
              </div>
              <div className="text-body max-w-[540px]">
                {t('P_ABOUT.SECTION-2.DESC')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section full">
        <div className="section-wrapper">
          <div className="grid gap-8 grid-cols-12">
            <div className="md:col-span-5 col-span-12 md:pt-10 order-2 md:order-1">
              <div className="h3 max-w-[540px]">
                {t('P_ABOUT.SECTION-3.TITLE')}
              </div>
              <div className="text-body max-w-[540px]">
                {t('P_ABOUT.SECTION-3.DESC')}
              </div>
            </div>
            <div className="md:col-span-6 col-span-10 col-start-3 md:col-start-7 order-1 md:order-2">
              <Image
                src="/v2/about/about-3.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
              />

              <Image
                src="/v2/about/about-4.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full xl:max-w-[400px] md:max-w-[200px] max-w-[240px] mr-auto md:ml-[-5%] xl:ml-[-25%] ml-[-15%] md:mt-[-20%] mt-[-30%]"
              />
            </div>
          </div>
        </div>
      </div>

      <Marquee />

      <section
        className="relative section full no-space md:aspect-banner flex items-center overflow-hidden"
        ref={ref}
      >
        <motion.div
          className="bg-parallax"
          style={{
            backgroundImage: `url(/v2/about/about-6.jpg)`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            y: yBg
          }}
        />
        <div className="section-wrapper px-8 grid gap-8 grid-cols-12 py-20 xl:py-0 relative text-white w-full">
          <div className="md:col-span-6 col-span-12 text-center self-center">
            <p className="lead-1">{t('P_ABOUT.SECTION-5.SLOGAN')}</p>
          </div>
          <div className="md:col-span-5 col-span-12 md:col-start-8 self-center mt-16 md:mt-0">
            <p className="h3">{t('P_ABOUT.SECTION-5.TITLEONE')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-5.TITLETWO')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-5.TITLETHREE')}</p>
            <p className="text-body mt-10">{t('P_ABOUT.SECTION-5.DESC')}</p>
          </div>
        </div>
      </section>

      <section
        className="relative section full no-space md:aspect-banner flex items-center overflow-hidden"
        ref={ref}
      >
        <motion.div
          className="bg-parallax"
          style={{
            backgroundImage: `url(/v2/about/about-5.jpg)`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            y: yBg
          }}
        />
        <div className="section-wrapper px-8 grid gap-8 grid-cols-12 py-20 xl:py-0 relative text-white w-full">
          <div className="md:col-span-6 col-span-12 text-center self-center">
            <p className="lead-1">{t('P_ABOUT.SECTION-6.SLOGAN')}</p>
          </div>
          <div className="md:col-span-5 col-span-12 md:col-start-8 self-center mt-16 md:mt-0">
            <p className="h3">{t('P_ABOUT.SECTION-6.TITLEONE')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-6.TITLETWO')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-6.TITLETHREE')}</p>
            <p className="text-body mt-10">{t('P_ABOUT.SECTION-6.DESC')}</p>
          </div>
        </div>
      </section>

      <section
        className="relative section full no-space md:aspect-banner flex items-center overflow-hidden"
        ref={ref}
      >
        <motion.div
          className="bg-parallax"
          style={{
            backgroundImage: `url(/v2/about/about-7.jpg)`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            y: yBg
          }}
        />
        <div className="section-wrapper px-8 grid gap-8 grid-cols-12 py-20 xl:py-0 relative text-white w-full">
          <div className="md:col-span-6 col-span-12 text-center self-center">
            <p className="lead-1">{t('P_ABOUT.SECTION-7.SLOGAN')}</p>
          </div>
          <div className="md:col-span-5 md:col-start-8 col-span-12 self-center mt-16 md:mt-0">
            <p className="h3">{t('P_ABOUT.SECTION-7.TITLEONE')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-7.TITLETWO')}</p>
            <p className="h3">{t('P_ABOUT.SECTION-7.TITLETHREE')}</p>
            <p className="text-body mt-10">{t('P_ABOUT.SECTION-7.DESC')}</p>
          </div>
        </div>
      </section>

      <StaticPagesCards />
    </Fragment>
  );
};

export default AboutPage;
